/**
 * Shared MenuProps for MUI Select so dropdowns open consistently across the app:
 * - Rendered in portal (not clipped by parent overflow)
 * - High z-index so menu appears on top
 * - Short max height so the list stays within the dropdown and doesn't overlap the next form field
 * - Opens below the field (anchorOrigin/transformOrigin)
 */
const DROPDOWN_MAX_HEIGHT = 220;

export const selectMenuProps = {
  disablePortal: false,
  style: { zIndex: 9999 },
  PopperProps: {
    modifiers: [{ name: 'offset', options: { offset: [0, -4] } }],
  },
  PaperProps: {
    style: {
      maxHeight: DROPDOWN_MAX_HEIGHT,
      overflow: 'hidden',
      zIndex: 9999,
      border: '1px solid rgba(0,0,0,0.12)',
      borderRadius: 4,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
  },
  MenuListProps: { style: { maxHeight: DROPDOWN_MAX_HEIGHT, overflowY: 'auto' } },
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
};
